
import { Options, Vue } from 'vue-class-component';
import { TransportDistanceCalculationClient } from '@/services/Services';
import EditModal from '../modals/editModal.vue';
import InfoModal from '@/components/modals/infoModal.vue';
import TransportUploadExcelModal from '../modals/transportUploadExcelModal.vue';
import * as OM from '@/Model';

@Options({
    components: {}
})
export default class Transport extends Vue {

    items: OM.TransportDistanceCalculationVM[] = [];
    loaded: boolean = false;

    created() {
        this.init();
    }

    init() {
        TransportDistanceCalculationClient.getAllConfigurations()
        .then(x => {
            this.items = x;
            this.loaded = true;
        })
    }

    editConfiguration(item: OM.TransportDistanceCalculationVM) {
        if(!item)
            item = new OM.TransportDistanceCalculationVM();

        this.$opModal.show(EditModal, {
            model: item,
            callback: (updatedModel: OM.TransportDistanceCalculationVM) => {
                TransportDistanceCalculationClient.editConfiguration(updatedModel)
                .then(x => {
                    this.init();
                    this.$opModal.closeLast();
                })
                .catch(y => {
                    this.$opModal.show(InfoModal, {
                        text: this.$localizationService.getLocalizedValue("Error", "Error"),
                        subtitle: y.Message,
                        deny: this.$localizationService.getLocalizedValue("Close", "Close"),
                        denyCb: () => {
                            this.$opModal.closeLast();
                        }
                    })
                })
            }
        })
    }

    uploadExcelModal() {
        this.$opModal.show(TransportUploadExcelModal, {
            callback: () => {
                this.$opModal.closeLast();
                this.init();
            }
        })
    }

}
